module.exports = __webpack_public_path__ + "img/nav-gateway.4c5b97e0.svg";